import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { PlayerButton } from './PlayerButton';
const READY_CLASS = {
    ready: 'hekate-player-sync-btn hekate-player-sync-btn--ready',
    waiting: 'hekate-player-sync-btn hekate-player-sync-btn--waiting',
    disconnected: 'hekate-player-sync-btn hekate-player-sync-btn--disconnected',
};
const READY_TOOLTIP = {
    ready: 'All followers ready',
    waiting: 'Waiting for followers to buffer',
    disconnected: 'Session disconnected',
};
/**
 * Non-interactive indicator for the leader: shows composite follower-ready
 * state. Orange while any follower is buffering (`KWAIT`), green once all
 * followers have sent `KREADY` (`KALLREADY` from the server).
 */
export function FollowerReadyButton({ manager }) {
    const [state, setState] = useState(manager.getReadyState());
    useEffect(() => {
        const off = manager.on('readyStateChange', (e) => setState(e.state));
        return () => { off(); };
    }, [manager]);
    return (_jsx(PlayerButton, { className: READY_CLASS[state], tooltip: READY_TOOLTIP[state], "aria-live": "polite", "data-ready-state": state }));
}
export default FollowerReadyButton;
